<script src="../../../api/wb/app/group.js"></script>
<style lang="scss">
	.tab-class {
		margin-top: 30px;
		.el-tabs__content{
			overflow: visible;
		}
	}
	.model-sort-box{
		.el-checkbox.is-bordered{
			margin-right: 15px;
			margin-left: 10px;
			margin-bottom: 15px;
		}
	}
</style>
<template>
	<div class="contentbox">
		<ul class="tabs-ul-list" style="margin-bottom: 30px;" v-if="platform == 'wb-dp'">
			<li v-for="(item, index) in tabPageName" :key="index">
				<a :class="item.value === selectPage ? 'active' : ''" @click="tabPageClick(item.value,item.name)">{{item.name}}</a>
			</li>
		</ul>
		<div class="media-add-ep-list">
			<div class="top-search" v-if="selectPage == 1">
				<el-form :inline="true" ref="formInline" :model="formInline" size="small" class="demo-form-inline">
					<!--<el-form-item label="" prop="appid">-->
					<!--<app-list @getAppId="getAppId" :appId="formInline.appId" :clear="'noclear'"></app-list>-->
					<!--</el-form-item>-->
					<!--<br/>-->
					<el-form-item>
						<el-button v-has="'wbdpGroup:add'" type="success" icon="el-icon-circle-plus-outline"
							@click="addData">添加组件</el-button>
						<!--<span class="succes-text" style="margin-left: 15px;">提示：投放链接进入的短剧，默认排在首个组件的首位</span>-->
					</el-form-item>
				</el-form>
			</div>
			<div class="tableTh" v-height>
				<el-table :data="tableData.result" border stripe style="width: 100%" height="100%" class="tableStyle td20">
					<el-table-column prop="moduleName" label="组件名称">
					</el-table-column>
					<el-table-column prop="typeName" label="组件类型">
						<template slot-scope="scope" class="ddd">
							<span>{{scope.row.typeName}}（{{scope.row.styleName}}）</span>
						</template>
					</el-table-column>
					<el-table-column prop="num" label="配置书籍">
					</el-table-column>
					<el-table-column prop="orderNo" label="排序">
					</el-table-column>
					<el-table-column label="状态">
						<template slot-scope="scope" class="ddd">
							<el-switch v-model="scope.row.status" active-color="#13ce66" disabled inactive-color="#ff4949"
								:active-value="0" :inactive-value="1">
							</el-switch>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="350">
						<template slot-scope="scope" class="ddd">
							<el-button v-has="'wbdpGroup:update'" type="primary" icon="el-icon-edit" size="mini"
								@click="handleEdit(scope.row.id)">编辑</el-button>
							<el-button v-has="'wbdpGroup:config'" type="defult" icon="el-icon-setting" size="mini"
								@click="handleBook(scope.row.moduleId, scope.row.typeId)">配置</el-button>
							<el-popover v-has="'wbdpGroup:delete'" width="160" :ref="scope.row.id" style="margin-left: 10px;">
								<p class="popover-con del">
									<i class="el-icon-question warnning-text"></i>确定删除吗？
								</p>
								<div style="text-align: right; margin: 0">
									<el-button size="mini" @click="$refs[scope.row.id].doClose()">取消</el-button>
									<el-button type="primary" size="mini" @click="handleDelete(scope.row.id)">确定</el-button>
								</div>
								<el-button slot="reference" type="danger" :disabled="scope.row.status == 0 ? true : false"
									icon="el-icon-delete" size="mini">删除</el-button>
							</el-popover>
							<!--<el-button type="danger" icon="el-icon-delete" size="mini" @click="handleDelete(scope.row.id)">删除</el-button>-->
						</template>
					</el-table-column>
				</el-table>
				<div class="foot-table" style="text-align:center;">
					<el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
						:page-sizes="[20, 50, 100, 200, 500]" :page-size="tableData.pageSize" background :current-page="currentPage"
						layout="sizes, prev, pager, next, jumper, ->, total" :total="tableData.totalNum">
					</el-pagination>
				</div>
			</div>
		</div>
		<!--添加-->
		<el-dialog :dialogTitle="dialogTitle" :visible.sync="dialogFormVisible" width="600px">
			<el-form :rules="rules" ref="ruleForm" :model="ruleForm" label-width="150px" class="input350"
				style="max-height: 480px;overflow: auto; padding-right: 20px;">
				<el-form-item label="组件名称：" prop="moduleName">
					<el-input v-model="ruleForm.moduleName" placeholder="请输入组件名称" clearable></el-input>
				</el-form-item>
				<el-form-item label="组件类型：" prop="typeId">
					<el-select v-model="ruleForm.typeId" filterable clearable placeholder="请选择组件类型">
						<el-option v-for="item in typeOptions" :key="item.id" :label="item.typeName" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="组件样式：" prop="styleId">
					<div v-if="ruleForm.typeId === 1">
						<el-select v-model="ruleForm.styleId" filterable clearable placeholder="请选择组件样式">
							<el-option v-for="item in styleOptions" :key="item.id" :label="item.styleName" :value="item.id">
							</el-option>
						</el-select>
					</div>
					<div v-else>
						<el-select v-model="ruleForm.styleId" filterable clearable placeholder="请选择组件样式">
							<el-option v-for="item in styleOptionsOne" :key="item.id" :label="item.styleName" :value="item.id">
							</el-option>
						</el-select>
					</div>
				</el-form-item>
				<el-form-item label="排序：" prop="path">
					<el-input type="number" v-model="ruleForm.orderNo" placeholder="请输入排序" clearable></el-input>
				</el-form-item>
				<el-form-item label="组件状态：" prop="status">
					<el-switch v-model="ruleForm.status" active-color="#13ce66"
						:disabled="ruleForm.change == 'upd' && ruleForm.num > 0 ? false : true" inactive-color="#ff4949"
						:active-value="0" :inactive-value="1" @change="changeStatus">
					</el-switch>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="editDialogSureBtn('ruleForm')">确 定</el-button>
			</div>
		</el-dialog>
		<!--配置-->
		<el-dialog title="配置书籍" :visible.sync="bookVisible" class="dialog-table" width="1200px"
			:before-close="closeDialogTableBook">
			<el-button type="success" icon="el-icon-circle-plus-outline" size="small" @click="addDataBook"
				style="margin-bottom: 25px;">添加书籍</el-button>
			<div class="tableTh">
				<el-table :data="tableDataBook.result" border stripe max-height="456" style="width: 100%;" class="tableStyle">
					<el-table-column label="封面" width="120">
						<template slot-scope="scope">
							<img class="cover-td" :src="scope.row.coverName" height="50" />
						</template>
					</el-table-column>
					<el-table-column label="书籍信息" width="280">
						<template slot-scope="scope">
							<div class="td-info">
								<p>书籍名：{{ scope.row.bookName }}</p>
								<p>别名：{{ scope.row.aliasName }}</p>
								<p>书籍ID：{{ scope.row.dataId }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="推荐封面" width="120">
						<template slot-scope="scope">
							<img class="cover-td" :src="scope.row.recCoverName" height="50" />
						</template>
					</el-table-column>
					<el-table-column label="推荐语">
						<template slot-scope="scope">
							<p>{{ scope.row.recContent }}</p>
						</template>
					</el-table-column>
					<el-table-column prop="statusOnline" label="状态" width="80">
						<template slot-scope="scope">
							<span v-if="scope.row.rackStatus == 0" class="danger-text">已下架</span>
							<span v-if="scope.row.rackStatus == 1" class="succes-text">上架中</span>
						</template>
					</el-table-column>
					<el-table-column prop="orderNo" label="排序" width="80">
					</el-table-column>
					<el-table-column label="操作" width="200">
						<template slot-scope="scope" class="ddd">
							<el-button type="primary" icon="el-icon-edit" size="mini"
								@click="handleEditOrderNo(scope.row.dataId)">编辑</el-button>
							<el-popover width="160" :ref="scope.row.dataId" style="margin-left: 10px;">
								<p class="popover-con del">
									<i class="el-icon-question warnning-text"></i>确定删除吗？
								</p>
								<div style="text-align: right; margin: 0">
									<el-button size="mini" @click="$refs[scope.row.dataId].doClose()">取消</el-button>
									<el-button type="primary" size="mini" @click="handleDeleteBook(scope.row.dataId)">确定</el-button>
								</div>
								<el-button slot="reference" type="danger" icon="el-icon-delete" size="mini">删除</el-button>
							</el-popover>
							<!--<el-button type="danger" icon="el-icon-delete" size="mini" @click="handleDelete(scope.row.id)">删除</el-button>-->
						</template>
					</el-table-column>
				</el-table>
				<div class="foot-table" style="text-align:center; padding-bottom: 20px;">
					<el-pagination @current-change="handleCurrentChangeBook" @size-change="handleSizeChangeBook"
						:page-sizes="[5, 20, 50, 100, 200, 500]" :page-size="tableDataBook.pageSize" background
						:current-page="currentPageBook" layout="sizes, prev, pager, next, jumper, ->, total"
						:total="tableDataBook.totalNum">
					</el-pagination>
				</div>
			</div>
			<!--<div slot="footer" class="dialog-footer">-->
			<!--<el-button @click="closeDialogTableVideo">取 消</el-button>-->
			<!--<el-button type="primary" @click="tableSureBtnVideo">确 定</el-button>-->
			<!--</div>-->
		</el-dialog>
		<!--配置（分类）-->
		<el-dialog title="配置书籍" :visible.sync="bookVisibleClass" class="dialog-table" width="1200px" :before-close="closeDialogTableBookClass">
			<div style="margin-bottom: 20px;">
				<el-button type="success" icon="el-icon-circle-plus-outline" size="small" @click="addBookSort">添加分类</el-button>
			</div>
			<div class="tab-class" style="position: relative">
				<ul class="tabs-ul-list" v-if="editType === 3">
					<li v-for="(item, index) in optionsTab" :key="index">
						<a :class="item.shortBookSortId === activeBookSortId ? 'active' : ''" @click="tabClick(item.shortBookSortId, item.shortBookSortName)">{{item.shortBookSortName}}</a>
					</li>
				</ul>
				<ul class="tabs-ul-list" v-if="editType === 4">
					<li v-for="(item, index) in optionsTab" :key="index">
						<a :class="item.longBookSortId === activeBookSortId ? 'active' : ''" @click="tabClick(item.longBookSortId, item.longBookSortName)">{{item.longBookSortName}}</a>
					</li>
				</ul>
				<!--<el-tabs v-model="activeClass" @tab-click="handleClick" v-if="optionsTab.length > 0">-->
					<!--<el-tab-pane v-for="(item, index) in optionsTab" :key="index" :label="item.shortBookSortName" :name="item.shortBookSortId">-->
						<!--<div style="text-align: right">-->
							<!--<el-button type="success" icon="el-icon-circle-plus-outline" size="small" @click="addDataBook" style="position: absolute; top: -65px; right: 0px;">添加短篇</el-button>-->
						<!--</div>-->
				<div style="position: relative">
					<div style="text-align: right">
						<el-button type="success" icon="el-icon-circle-plus-outline" size="small" @click="addDataBook" style="position: absolute; top: -70px; right: 0px;">添加书籍</el-button>
					</div>
					<div class="tableTh" style="margin-top: 30px;">
						<el-table :data="tableDataBook.result" border stripe max-height="456" style="width: 100%;" class="tableStyle">
							<el-table-column label="封面" width="120">
								<template slot-scope="scope">
									<img class="cover-td" :src="scope.row.coverName" height="50" />
								</template>
							</el-table-column>
							<el-table-column label="书籍信息" width="280">
								<template slot-scope="scope">
									<div class="td-info">
										<p>书籍名：{{ scope.row.bookName }}</p>
										<p>别名：{{ scope.row.aliasName }}</p>
										<p>书籍ID：{{ scope.row.dataId }}</p>
									</div>
								</template>
							</el-table-column>
							<el-table-column label="推荐封面" width="120">
								<template slot-scope="scope">
									<img class="cover-td" :src="scope.row.recCoverName" height="50" />
								</template>
							</el-table-column>
							<el-table-column label="推荐语">
								<template slot-scope="scope">
									<p>{{ scope.row.recContent }}</p>
								</template>
							</el-table-column>
							<el-table-column prop="statusOnline" label="状态" width="80">
								<template slot-scope="scope">
									<span v-if="scope.row.rackStatus == 0" class="danger-text">已下架</span>
									<span v-if="scope.row.rackStatus == 1" class="succes-text">上架中</span>
								</template>
							</el-table-column>
							<el-table-column prop="orderNo" label="排序" width="80">
							</el-table-column>
							<el-table-column label="操作" width="260">
								<template slot-scope="scope" class="ddd">
									<el-button type="primary" icon="el-icon-edit" size="mini" @click="handleEditOrderNo(scope.row.dataId)">编辑</el-button>
									<el-popover width="160" :ref="scope.row.dataId" style="margin-left: 10px;">
										<p class="popover-con del">
											<i class="el-icon-question warnning-text"></i>确定删除吗？
										</p>
										<div style="text-align: right; margin: 0">
											<el-button size="mini" @click="$refs[scope.row.dataId].doClose()">取消</el-button>
											<el-button type="primary" size="mini" @click="handleDeleteBook(scope.row.dataId)">确定</el-button>
										</div>
										<el-button slot="reference" type="danger" icon="el-icon-delete" size="mini">删除</el-button>
									</el-popover>
									<!--<el-button type="danger" icon="el-icon-delete" size="mini" @click="handleDelete(scope.row.id)">删除</el-button>-->
								</template>
							</el-table-column>
						</el-table>
						<div class="foot-table" style="text-align:center; padding-bottom: 20px;">
							<el-pagination @current-change="handleCurrentChangeBook" @size-change="handleSizeChangeBook" :page-sizes="[5, 20, 50, 100, 200, 500]" :page-size="tableDataBook.pageSize" background :current-page="currentPageBook" layout="sizes, prev, pager, next, jumper, ->, total" :total="tableDataBook.totalNum">
							</el-pagination>
						</div>
					</div>
				</div>
					<!--</el-tab-pane>-->
				<!--</el-tabs>-->
			</div>
		</el-dialog>
		<el-dialog title="编辑分类" :visible.sync="dialogFormBookSort" width="800px">
			<!--<el-select v-model="valueSort" multiple placeholder="请选择" @change="changeBookSort" style="display: block; margin-bottom: 15px;">-->
				<!--<el-option-->
				<!--v-for="item in optionsBookSort"-->
				<!--:key="item.shortBookSortId"-->
				<!--:label="item.shortBookSortName"-->
				<!--:value="item.shortBookSortId" style="width: 100%">-->
				<!--</el-option>-->
			<!--</el-select>-->
			<div class="model-sort-box">
				<el-checkbox-group v-if="editType === 3" v-model="valueSort" @change="changeBookSort">
					<el-checkbox border v-for="item in optionsBookSort" :label="item.shortBookSortId" :key="item.shortBookSortId">{{item.shortBookSortName}}</el-checkbox>
				</el-checkbox-group>
				<el-checkbox-group v-if="editType === 4" v-model="valueSort" @change="changeBookSort">
					<el-checkbox border v-for="item in optionsBookSort" :label="item.longBookSortId" :key="item.longBookSortId">{{item.longBookSortName}}</el-checkbox>
				</el-checkbox-group>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormBookSort = false">取 消</el-button>
				<el-button type="primary" v-debounce:500="editDialogSureBookSort">确 定</el-button>
			</div>
		</el-dialog>
		<!--修改配置排序弹框-->
		<el-dialog title="编辑" :visible.sync="dialogFormVisibleOrderNo" width="600px">
			<el-form :rules="rulesOrderNo" ref="ruleFormOrderNo" :model="ruleFormOrderNo" label-width="120px" class="input350"
				style="max-height: 480px;overflow: auto; padding-right: 20px;">
				<el-form-item label="书籍名：">
					<span>{{ ruleFormOrderNo.bookName }}</span>
				</el-form-item>
				<el-form-item label="排序：" prop="orderNo">
					<el-input type="number" v-model="ruleFormOrderNo.orderNo"></el-input>
					<p class="input-note">数字越大,优先级越高</p>
				</el-form-item>
				<el-form-item label="推荐封面：" prop="recCoverName">
					<el-upload class="avatar-uploader" action="" :http-request="handleUpimg" :show-file-list="false" :on-change="onChange" :on-exceed="handleExceed" :file-list="fileList" :limit="1" accept="image/png, image/jpeg">
						<img v-if="ruleFormOrderNo.recCoverName" :src="ruleFormOrderNo.recCoverName" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
				<el-form-item label="推荐语：" prop="recContent">
					<el-input type="textarea" rows="5" v-model="ruleFormOrderNo.recContent" placeholder="请输入推荐语" clearable></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisibleOrderNo = false">取 消</el-button>
				<el-button type="primary" @click="editDialogSureBtnOrderNo('ruleFormOrderNo')">确 定</el-button>
			</div>
		</el-dialog>
		<book-table-more :visible.sync="isShowDialogBook" :appId="formInline.appId" @bookSure="bookSure" :activeBookSortId="activeBookSortId"
			@cancelDialogBook="cancelDialogBook" :modelBookSort="activeBookSortName" :typeBookSort="editType"></book-table-more>
	</div>
</template>
<script>
// import AppList from '@/components/AppList'
import BookTableMore from '@/components/wbdp/BookTableMore'
import { listModule, addModule, details, delModule, listBook, listBookAdd, detailsBook, updBookData, delBook, moduleType, moduleStyle, listBookSort, listBookSortFirst, moduleBookSort, moduleBookSortFirst} from "@/api/wb/app/group";
import axios from 'axios';
export default {
	components: {
		// AppList,
		BookTableMore
	},
	data() {
		var validateNum = (rule, value, callback) => {
			if (!(/(^[1-9]\d*$)/.test(value))) {
				return callback(new Error('数字应为正整数'));
			} else {
				callback();
			}
		};
		return {
            platform: localStorage.getItem('platform'),
            tabPageName: [
                {
                    value: 1,
                    name: '首页组件配置'
                },
                {
                    value: 2,
                    name: '阅读页组件配置'
                }
            ],
            selectPage: 1,
			formInline: {
				appId: localStorage.getItem('appId'),
				pageTypeId: 1
			},
			dialogTitle: '添加组件',
			tableData: { // 组件表格
				pageSize: 20,
				pageNo: 1,
				totalPage: 1,
				totalNum: 0,
				result: [
				]
			},
			currentPage: 1,
			tableDataBook: { // 组件下的图书表格
				pageSize: 5,
				pageNo: 1,
				totalPage: 1,
				totalNum: 0,
				result: [
				]
			},
			currentPageBook: 1,
			dialogFormVisible: false, // 组件- 编辑
			typeOptions: [ // 组件- 类型
			],
			styleOptions: [ // 组件- 样式
			],
            styleOptionsOne: [ // 组件- 样式
            ],
			ruleForm: { // 组件- 表单
				id: '',
				appId: '',
				change: 'add',
				moduleName: '',
				typeId: '',
				styleId: '',
				orderNo: '',
				status: 1
			},
			editIndex: -1,
			rules: {
				moduleName: [
					{ required: true, message: '请输入组件名称', trigger: 'blur' }
				],
				typeId: [
					{ required: true, message: '请选择组件类型', trigger: 'change' }
				],
				styleId: [
					{ required: true, message: '请选择组件样式', trigger: 'change' }
				],
				orderNo: [
					{ required: true, message: '请输入排序', trigger: 'blur' },
					{ validator: validateNum, trigger: 'blur' }
				]
			},
			dialogFormVisibleOrderNo: false, // 组件- 顺序编辑弹框
			ruleFormOrderNo: { // 组件- 顺序编辑表单
				dataId: '',
				bookName: '',
				orderNo: 1,
				recContent: '',
				recCoverName: '',
			},
			rulesOrderNo: {
				orderNo: [
					{ required: true, message: '请输入排序', trigger: 'blur' },
					{ validator: validateNum, trigger: 'blur' }
				]
			},
			bookVisible: false, // 配置
            bookVisibleClass: false, // 配置（分类）
			isShowDialogBook: false, // 通用组件 --- 选择图书
			selectBook: {},
			dataIds: '', 	// 短剧ID
			moduleId: '',  // 组件 - 编辑ID
            dialogFormBookSort: false, // 分类 -- 编辑二级分类弹框
			editType: 1,
            valueSort: [],  // 分类 -- 二级分类回显
            optionsBookSort: [{  // 所有二级分类列表
            }],
            optionsTab: [ // 所添加的二级分两类
			],
            activeBookSortId: null, // 回显 - 默认选中的二级分类
            activeBookSortName: '', // 回显 - 默认选中的二级分类
			fileList: [],
			
		}
	},
	computed: {},
	watch: {
		// openSwitchCount() {
		// 	return this.tableData.result.filter(item => item.status == 1).length;
		// 	// console.log(this.tableData.result.filter(item => item.status == 1).length)
		// }
	},
	mounted: function () {
		this.getTableData()
		this.getModuleType()
        this.getModuleStyle()
	},
	methods: {
        tabPageClick (value, name) {
            // this.$router.push({ path:  path})
            this.selectPage = value
            console.log(name)
			this.formInline.pageTypeId = value
			this.getTableData()
        },
		search() {
			this.currentPage = 1
			this.getTableData()
		},
		resetQuery() {
			this.$refs['formInline'].resetFields()
			this.getTableData()
		},
		// 从组件获取appid
		getAppId(data) {
			this.formInline.appId = data
			this.getTableData()
		},
		closeDialog() {
			this.$refs['ruleForm'].resetFields()
		},
		// 添加组件 --------------------------------------- 相关方法
		handleCurrentChange(value) {
			this.currentPage = value
			this.getTableData()
		},
		// pageSize切换
		handleSizeChange(val) {
			this.tableData.pageSize = val
			this.currentPage = 1
			this.getTableData()
		},
		changeStatus(val) {
			console.log(val)
		},
		// 编辑
		handleEdit(id) {
			if (this.$refs['ruleForm'] !== undefined) {
				this.$refs['ruleForm'].resetFields()
			}
			this.dialogTitle = '编辑组件'
			this.dialogFormVisible = true
			this.getDetails(id)
		},
		getDetails(id) {
			details({
				id: id
			}).then(response => {
				if (response.data.head.flag === 0) {
					this.ruleForm = response.data.content
					this.ruleForm.change = 'upd'
				} else {
					this.$message.error(response.data.head.desc)
				}
			});
		},
		addData() {
			this.dialogFormVisible = true
			this.dialogTitle = '添加组件'
			this.ruleForm = {
				id: '',
				appId: this.formInline.appId,
				change: 'add',
				moduleName: '',
				typeId: '',
				styleId: '',
				orderNo: '',
				status: 1
			}
			if (this.$refs['ruleForm'] !== undefined) {
				this.$refs['ruleForm'].resetFields()
			}
		},
		// 弹框确定
		editDialogSureBtn(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					if (this.ruleForm.change == 'upd') { // 编辑
						if (this.tableData.result.filter(item => item.status == 0).length == 1 && this.ruleForm.status == 1) {
							this.$message.error('至少需要开启一个组件模块')
						} else {
							this.saveTableData()
						}
					} else { // 添加
						this.saveTableData()
					}
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		// 保存编辑信息
		saveTableData() {
			addModule(this.ruleForm).then(response => {
				if (response.data.head.flag === 0) {
					this.$message({
						message: '提交成功',
						type: 'success'
					});
					this.getTableData()
					this.dialogFormVisible = false
				} else {
					this.$message.error(response.data.head.desc);
				}
			})
		},
		handleDelete(id) {
			delModule({
				id: id,
			}).then(response => {
				if (response.data.head.flag === 0) {
					if (this.tableData.result.length === 1 && this.currentPage > 1) {
						this.currentPage = this.currentPage - 1
					}
					this.$refs[id].doClose()
					this.getTableData()
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				} else {
					this.$message.error(response.data.head.desc);
				}
			})
		},
		// 获取组件列表
		getTableData() {
			let json2 = {
				pageNo: this.currentPage,
				pageSize: this.tableData.pageSize
			};
			let json1 = this.formInline;
			let paramJson = { ...json1, ...json2 };
			console.log(paramJson)
			listModule(paramJson).then(response => {
				if (response.data.head.flag === 0) {
					this.tableData = response.data.content
				} else {
					this.$message.error(response.data.head.desc)
				}
			});
		},
		// 添加短篇 --------------------------------------- 相关方法
		addDataBook() {
			this.isShowDialogBook = true
		},
		handleBook(id, type) {
			console.log(id)
			this.moduleId = id
			this.editType = type
			if (type == 3 || type == 4) {
                this.getlistBookSort()
                this.getModuleBookSort('show')
                this.bookVisibleClass = true
			} else {
                this.activeBookSortId = null
				this.activeBookSortName = ''
                this.bookVisible = true
                this.getTableDataBook()
			}
			this.currentPageBook = 1
		},
		// 关闭选剧弹窗
		cancelDialogBook(data) {
			console.log('cancel')
			this.isShowDialogBook = data
		},
		// 确定剧
		bookSure(data) {
			console.log("确定剧", data)
			this.dataIds = data.bookListStr
			this.selectBook = data
			listBookAdd({
				dataIds: this.dataIds,
				moduleId: this.moduleId
			}).then(response => {
				if (response.data.head.flag === 0) {
					this.getTableDataBook()
					this.getTableData()
				} else {
					this.$message.error(response.data.head.desc)
				}
			});
		},
		closeDialogTableBook() {
			this.bookVisible = false
		},
        closeDialogTableBookClass() {
            this.bookVisibleClass = false
        },
		tableSureBtnBook() {
			this.bookVisible = false
		},
		handleCurrentChangeBook(value) {
			this.currentPageBook = value
			this.getTableDataBook()
		},
		// pageSize切换
		handleSizeChangeBook(val) {
			this.tableDataBook.pageSize = val
			this.currentPageBook = 1
			this.getTableDataBook()
		},
		getTableDataBook() {
            let json2 = {
                moduleId: this.moduleId,
                pageNo: this.currentPageBook,
                pageSize: this.tableDataBook.pageSize,
                shortBookSortId: '',
                longBookSortId: ''
			}
            if (this.editType == 3) {
                json2.shortBookSortId = this.activeBookSortId
                json2.longBookSortId = ''
            } else {
                json2.shortBookSortId = ''
                json2.longBookSortId = this.activeBookSortId
            }
			let json1 = this.formInline;
			let paramJson = { ...json1, ...json2 };
			listBook(paramJson).then(response => {
				if (response.data.head.flag === 0) {
					this.tableDataBook = response.data.content
				} else {
					this.$message.error(response.data.head.desc)
				}
			});
		},
		handleDeleteBook(dataId) {
			delBook({
				dataId: dataId,
				moduleId: this.moduleId
			}).then(response => {
				if (response.data.head.flag === 0) {
					if (this.tableData.result.length === 1 && this.currentPage > 1) {
						this.currentPage = this.currentPage - 1
					}
					this.$refs[dataId].doClose()
					this.getTableDataBook()
					this.getTableData()
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				} else {
					this.$message.error(response.data.head.desc);
				}
			})
		},
		// 编辑 ------------ 配置排序
		// handleEditOrderNo(row) {
		// 	this.ruleFormOrderNo.dataId = row.dataId
		// 	this.ruleFormOrderNo.videoName = row.videoName
		//    this.ruleFormOrderNo.orderNo = row.orderNo
		//    if (this.$refs['ruleForm'] !== undefined) {
		//        this.$refs['ruleForm'].resetFields()
		//    }
		// 	this.dialogFormVisibleOrderNo = true
		// },
		// 编辑
		handleEditOrderNo(dataId) {
			if (this.$refs['ruleForm'] !== undefined) {
				this.$refs['ruleForm'].resetFields()
			}
			this.dialogFormVisibleOrderNo = true
			this.fileList = []
			this.getDetailsBook(dataId)
		},
		getDetailsBook(dataId) {
			detailsBook({
				dataId: dataId,
				moduleId: this.moduleId
			}).then(response => {
				if (response.data.head.flag === 0) {
					this.ruleFormOrderNo.dataId = response.data.content.dataId
					this.ruleFormOrderNo.bookName = response.data.content.bookName
					this.ruleFormOrderNo.orderNo = response.data.content.orderNo
					this.ruleFormOrderNo.recContent = response.data.content.recContent
					this.ruleFormOrderNo.recCoverName = response.data.content.recCoverName
				} else {
					this.$message.error(response.data.head.desc)
				}
			});
		},
		// 弹框确定
		editDialogSureBtnOrderNo(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.saveTableDataOrderNo()
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		// 保存编辑信息
		saveTableDataOrderNo() {
			updBookData({
				dataId: this.ruleFormOrderNo.dataId,
				moduleId: this.moduleId,
				orderNo: this.ruleFormOrderNo.orderNo,
				recContent: this.ruleFormOrderNo.recContent,
				recCoverName: this.ruleFormOrderNo.recCoverName,
			}).then(response => {
				if (response.data.head.flag === 0) {
					this.$message({
						message: '提交成功',
						type: 'success'
					});
					this.getTableDataBook()
					this.dialogFormVisibleOrderNo = false
				} else {
					this.$message.error(response.data.head.desc);
				}
			})
		},
        // 获取组件类型列表
        getModuleType() {
            moduleType({
            }).then(response => {
                if (response.data.head.flag === 0) {
                    // this.typeOptions = response.data.content
					// 不包含分类组件
					this.typeOptions = response.data.content.filter(item => item.id != 3 && item.id != 4)
					// console.log("分类组件----",this.typeOptions)
                } else {
                    this.$message.error(response.data.head.desc)
                }
            });
        },
        addBookSort() {
            this.getModuleBookSort('show')
            this.dialogFormBookSort = true
        },
        // 获取组件样式列表
        getModuleStyle() {
            moduleStyle({
            }).then(response => {
                if (response.data.head.flag === 0) {
                    this.styleOptions = response.data.content
                    this.styleOptionsOne = response.data.content.filter((item, index) => item.id == 1);
                } else {
                    this.$message.error(response.data.head.desc)
                }
            });
        },
        getlistBookSort() {
            console.log('type', this.editType)
            if (this.editType == 3) {
                listBookSort({
                }).then(response => {
                    if (response.data.head.flag === 0) {
                    this.optionsBookSort = response.data.content
                } else {
                    this.$message.error(response.data.head.desc)
                }
            });
            } else if (this.editType == 4) {
                listBookSortFirst({
                }).then(response => {
                    if (response.data.head.flag === 0) {
						this.optionsBookSort = response.data.content
					} else {
						this.$message.error(response.data.head.desc)
					}
				});
            }
        },
        changeBookSort(val) {
            console.log(val)
		},
        editDialogSureBookSort() {
            this.saveBookSort()
        },
        saveBookSort() {
            var that = this
			if (this.editType == 3) {
                this.axios({
                    method: 'post',
                    url: '/novel/module/addModuleBookSort/saveOrDel',
                    params:{
                        moduleId: that.moduleId
                    },
                    data: that.valueSort
                }).then((response) => {
                    if (response.data.head.flag === 0) {
						this.$message({
							message: '提交成功',
							type: 'success'
						});
						that.dialogFormBookSort = false
						this.getModuleBookSort('show')
					} else {
						this.$message.error(response.data.head.desc)
					}
				})
            } else if (this.editType == 4) {
                this.axios({
                    method: 'post',
                    url: '/novel/module/addModuleLongBookSort/saveOrDel',
                    params:{
                        moduleId: that.moduleId
                    },
                    data: that.valueSort
                }).then((response) => {
                    if (response.data.head.flag === 0) {
						this.$message({
							message: '提交成功',
							type: 'success'
						});
						that.dialogFormBookSort = false
						this.getModuleBookSort('show')
					} else {
						this.$message.error(response.data.head.desc)
					}
				})
			}
        },
        getModuleBookSort(edit) {
            var that = this
			if (this.editType == 3) {
                moduleBookSort({
                    moduleId: that.moduleId
                }).then(response => {
                    if (response.data.head.flag === 0) {
						this.optionsTab = response.data.content
						if (edit == 'show'){
							that.activeBookSortId = response.data.content[0].shortBookSortId
							that.activeBookSortName = response.data.content[0].shortBookSortName
							that.valueSort = response.data.content.map(response => response.shortBookSortId)
							console.log('分类回显', that.valueSort)
							that.getTableDataBook()
						}
					} else {
						this.$message.error(response.data.head.desc)
					}
				});   
			} else if (this.editType == 4) {
                moduleBookSortFirst({
                    moduleId: that.moduleId
                }).then(response => {
                    if (response.data.head.flag === 0) {
                    this.optionsTab = response.data.content
                    if (edit == 'show'){
                        that.activeBookSortId = response.data.content[0].longBookSortId
                        that.activeBookSortName = response.data.content[0].longBookSortName
                        that.valueSort = response.data.content.map(response => response.longBookSortId)
                        console.log('分类回显', that.valueSort)
                        that.getTableDataBook()
                    }
                } else {
                    this.$message.error(response.data.head.desc)
                }
            });
			}
        },
        tabClick (value, name) {
            // this.$router.push({ path:  path})
            this.activeBookSortId = value
			this.activeBookSortName = name
			this.getTableDataBook()
        },

		// 推荐封面上传
		handleUpimg(params, fileList) {
			const {dataId} = this.ruleFormOrderNo
			// console.log("推荐封面上传id",Number(dataId),params.file);
			if(!dataId){
				this.$message.error(`未找到书籍！`);
				return ;
			}
			const formData = new FormData();
			formData.append('file', params.file);
			formData.append('bookid', Number(dataId));
			const config = {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			};
			axios.post('/novel/module/uploadresImage', formData, config).then(({ data }) => {
				if (data.head.flag === 0) {
					console.log("上传成功",data.content.imgPath)
					this.$message.success("上传成功！")
					this.ruleFormOrderNo.recCoverName = data.content.imgPath
					this.fileList = []
				} 
			}).catch(error => {
				console.error(`文件上传异常`, error);
				this.$message.error(`文件上传异常`);
				this.ruleFormOrderNo.recCoverName = ''
				this.fileList = []
			});
		},

		handleExceed(files, fileList){
			this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
		},
		onChange(file, fileList){
			console.log("onChange",file,fileList)
			const typeArray = ['image/png','image/jpeg']
			const isJPG = typeArray.indexOf(file.raw.type);
			if (isJPG === -1) {
				this.$message.error('当前支持上传.png,.jpg格式！')
				fileList.pop()
			}
			this.fileList = fileList
		},
	}
}
</script>
